import "Layouts/default";

import { Vue, i18n } from "Common/vue";
import RecipeProducts from "VueComponents/RecipeProducts/main.vue";
import { initAnchors } from "Functions/anchor";

import "Ui/slider";
import "Ui/more-items";
import "Ui/favorite-trigger";
import "Common/social";

for (const printTrigger of document.querySelectorAll(".js-print-link")) {
    printTrigger.addEventListener("click", (event) => {
        event.preventDefault();
        window.print();
    });
}

const recipeProductsEl = document.querySelector(".js-vue-recipe-products");
if (recipeProductsEl) {
    const placeholder = recipeProductsEl.innerHTML;

    window.$_recipe_products = new Vue({
        i18n,
        render: (h) =>
            h(RecipeProducts, {
                props: {
                    ...{ placeholder },
                    ...recipeProductsEl.dataset,
                },
            }),
    }).$mount(".js-vue-recipe-products");
}

initAnchors();
